export default __webpack_public_path__ + "static/media/project_1.0dad308a.jpg";